export default {
  /**
   * Development
   *
   */
  // apiUri: 'https://staging-bye.dddtl.net/api/v1/',
  // apiHost: 'https://staging-bye.dddtl.net',

  /**
   * Production
   *
   */
  apiUri: 'https://api.beforeyoueat.id/api/v1/',
  apiHost: 'https://api.beforeyoueat.id',

  /**
   * Localhost
   *
   */
  // apiUri: 'http://localhost:5718/api/v1/',
  // apiHost: 'http://localhost:5718',

  appPath: '/',
  uri(uri: string) {
    return `${this.apiUri}${uri}`;
  },
  appName: 'Before You Eat',
  appUri: 'https://beforeyoueat.id/',
  apiKey: '3577c7bf7dsa7232dsadsd123-670f2eb21c4__',
};
